import { SkeletonLoader } from 'src/components/skeleton';
import PlanItem from './PlanItem';
import useSubscriptions from 'src/hooks/useSubscriptions';
import { PlanType, UserPlan } from 'src/@types/feature';
import { AppGridContainer, AppGridContent } from 'src/components';

//
//

interface PlanListProps {
  selectedBtn: PlanType;
  subscriptionPlans: UserPlan[] | null;
}

const PlanList: React.FC<PlanListProps> = ({
  selectedBtn,
  subscriptionPlans,
}) => {
  const { subscriptions, isPlansLoading } = useSubscriptions();
  const current = subscriptions?.currentSubscriptions;

  return (
    <AppGridContainer justifyContent="center">
      {(isPlansLoading || !subscriptionPlans ? [...Array(3)] : subscriptionPlans).map((plan, idx: number) => {
        if (plan) {
          const matchPlan = current?.find(el => el?.planLevel === plan?.planLevel);

          return (
            <PlanItem
              plan={plan}
              matchPlan={matchPlan}
              currentSubscriptions={current}
              idx={idx}
              key={idx}
              selectedBtn={selectedBtn}
            />
          );
        } else {
          return (
            <AppGridContent size={{ xs: 12, sm: 6, md: 4 }} key={idx}>
              <SkeletonLoader height={600} sx={{ m: 0 }} />
            </AppGridContent>
          );
        }
      })}
    </AppGridContainer>
  );
};

export default PlanList;
